// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { faTwitter  as fabFaTwitter  } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faFacebookF as fabFaFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faYoutube  as fabFaYoutube  } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faLinkedinIn as fabFaLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";

import { faAlignRight   as fasFaAlignRight   } from "@fortawesome/pro-solid-svg-icons/faAlignRight";
import { faAngleDown    as fasFaAngleDown    } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { faComments     as fasFaComments     } from "@fortawesome/pro-solid-svg-icons/faComments";
import { faSearch       as fasFaSearch       } from "@fortawesome/pro-solid-svg-icons/faSearch";
import { faShoppingCart as fasFaShoppingCart } from "@fortawesome/pro-solid-svg-icons/faShoppingCart";

/**
 * Add brand icons
 */
library.add(fabFaTwitter, fabFaFacebookF, fabFaYoutube, fabFaLinkedinIn);

/**
 * Add solid icons
 */
library.add(fasFaAlignRight, fasFaAngleDown, fasFaComments, fasFaSearch, fasFaShoppingCart);

/**
 * Watch the DOM to insert icons
 */
dom.watch();
